<template>
    <div>
        <div class="az-form-content">
            <v-flex xs12 md3 d-flex>
                <v-select oulined
                          :disabled="execucoes.length < 2"
                          :items="execucoes"
                          item-id="id"
                          :item-text=" (item) => `${item.numero} - Repetição ${item.repeticao}`"
                          label="Execuções"
                          v-model="execucaoSelecionado"
                          return-object
                          @change="selecionarExecucao($event)"
                          />
            </v-flex>
            <v-flex xs12 d-flex v-if="lotes.length <= 0 && itens.length <= 0">
                <v-alert
                    :value="lotes.length <= 0 && itens.length <= 0"
                    color="#fff3cd"
                    icon="priority_high"
                    style="color: #664d03 !important"
                >
                    Este processo não possui nenhuma execução. Não encontramos os itens/lotes deste processo.
                </v-alert>
            </v-flex>
            <div>
                <painel-lote-legado v-if="lotes.length > 0"
                                          v-model="lotes"
                                          :possuiValorReferencia="true"
                                          prefixOuSuffixValor="R$"
                                          criterioJulgamento="MENOR_PRECO"
                                          :isCriterioJulgamentoMaiorDesconto="false"
                                          :casasDecimais="2"
                                          :casasDecimaisQuantidade="2"/>

                <painel-item-legado v-if="itens.length > 0"
                                          v-model="itens"
                                          :possuiValorReferencia="true"
                                          prefixOuSuffixValor="R$"
                                          criterioJulgamento="MENOR_PRECO"
                                          :isCriterioJulgamentoMaiorDesconto="false"
                                          :casasDecimais="2"
                                          :casasDecimaisQuantidade="2"/>
            </div>
        </div>
    </div>
</template>

<script>
import {actionTypes, criteriosJulgamento, mutationTypes} from '@/core/constants'
import PainelLoteLegado from '@/views/pages/comprador/legado/components/PainelLoteLegado.vue'
import PainelItemLegado from '@/views/pages/comprador/legado/components/PainelItemLegado.vue'

export default {
    name: 'ItensLotesEdicao',
    components: {
        PainelItemLegado,
        PainelLoteLegado,
    },
    data() {
        return {
            compraLegadaId: null,
            itens: [],
            lotes: [] ,
            resumoCompraDireta: {},
            execucoes:[],
            execucaoSelecionado:{}
        }
    },
    computed: {
        prefixOuSuffixValor(){
            return this.resumoCompraDireta.prefixoValor
        },
        criterioJulgamento(){
            return this.resumoCompraDireta.criterioJulgamento
        },
        isCriterioJulgamentoMaiorDesconto(){
            return this.resumoCompraDireta.criterioJulgamento === criteriosJulgamento.MAIOR_DESCONTO.valor
        },
        prefix(){
            return this.resumoCompraDireta.prefixoValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.resumoCompraDireta.prefixoValor === '%' ? '%' : ''
        }
    },
    async created() {
        try {
            this.setCompraLegadaId()
            await this.buscarExecucoesProcesso()

            this.execucaoSelecionado = this.execucoes.length > 0 ? this.execucoes[0] : {id: 0, numero: 'Selecione uma execução'}
        }catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        setCompraLegadaId() {
            this.compraLegadaId = this.$route.params.id
        },
        async buscarExecucoesProcesso(){
            const resultado = await this.$store.dispatch(actionTypes.LEGADO.BUSCAR_EXECUCOES_POR_PROCESSO, this.compraLegadaId)
            this.execucoes = [ ...resultado.execucoes ]
        },
        async buscarItensLotes() {
            if(!this.execucaoSelecionado.id) return

            const data = { processoAquisicaoId: this.compraLegadaId, execucaoId: this.execucaoSelecionado.id }

            const resultado = await this.$store.dispatch(actionTypes.LEGADO.BUSCAR_ITENS_LOTES, data)

            this.itens = [ ...resultado.itens ]
            this.lotes = [ ...resultado.lotes ]
        },
        selecionarExecucao(execucao) {
            this.$store.commit(mutationTypes.SET_EXECUCAO_ATIVA, execucao)
        }
    },
    watch: {
        'execucoes.length'(value) {
            if(value > 0) this.execucaoSelecionado = this.execucoes.find(ex => ex.repeticao === 0) || this.execucoes[0]
            this.buscarItensLotes()
            this.selecionarExecucao(this.execucaoSelecionado)
        }
    }
}
</script>

<style scoped lang="stylus">
.az-actions-form
    padding 0
</style>